import { render, staticRenderFns } from "./detail-colors.vue?vue&type=template&id=a0850160&scoped=true&"
import script from "./detail-colors.vue?vue&type=script&lang=js&"
export * from "./detail-colors.vue?vue&type=script&lang=js&"
import style0 from "./detail-colors.vue?vue&type=style&index=0&id=a0850160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0850160",
  null
  
)

export default component.exports